import { districtUrls } from '../../../common/routes/urls/district';
import { previewUrl } from '../../../hooks/useTourPreview';
import { isViewable, sortTimeline } from '../../../types';
import { mergedPhotos, mergedTimeline, orgStoryLens, publicParcelView } from '../../_shared/parcel-view/merge';
// How many timeline entries the tour view picks out before pointing at the full history.
const KEY_TIMELINE_COUNT = 5;
export const FULL_TIMELINE_ID = 'tour-home-full-timeline';
export const hasText = (x) => x.trim().length > 0;
// The way back from a tour home that has nothing to show, for its button.
export const backToTour = (tourId, previewing) => ({ href: previewUrl(districtUrls.toursDetail.getURL({ id: tourId }), previewing), label: 'Back to the tour' });
export const galleryUrl = (data) => previewUrl(districtUrls.toursHomePhotos.getURL({ id: data.tour.id, stopId: data.stop.id }), data.previewing);
// The parcel as the tour presents it: the community's curated view of it when the stop names one,
// else the property the tour added, on its own.
export const tourLens = (view, stop) => {
    const story = view.orgStories.find(s => s.id === stop.parcelViewId && s.status === 'published');
    if (story !== undefined)
        return orgStoryLens(view, story);
    return Object.assign(Object.assign({}, view), { properties: view.properties.filter(p => p.id === stop.propertyId) });
};
export const tourStory = (view, stop) => { var _a; return (_a = view.orgStories.find(s => s.id === stop.parcelViewId && s.status === 'published')) !== null && _a !== void 0 ? _a : null; };
// Everything the public may see of the parcel, across every contributor: the 76UNBOXED profile.
export const unboxedLens = (view) => publicParcelView(view);
const oldestFirst = (rows) => [...rows].sort((a, b) => sortTimeline(a, b, false));
// The curated selection's featured entries first, topped up from the rest, then read as a story
// from the oldest entry on.
export const keyTimeline = (view) => {
    const rows = oldestFirst(mergedTimeline(view, null).map(c => c.row));
    const picked = [...rows.filter(r => r.isFeatured), ...rows.filter(r => !r.isFeatured)].slice(0, KEY_TIMELINE_COUNT);
    return oldestFirst(picked);
};
export const fullTimeline = (view) => oldestFirst(mergedTimeline(view, null).map(c => c.row));
// Every photo on the house's public profile.
export const profilePhotos = (view) => mergedPhotos(unboxedLens(view), null).map(c => c.row);
// The tour's own photos lead; the rest of the public profile follows, each photo once.
export const tourPhotos = (view, stop) => {
    const curated = mergedPhotos(tourLens(view, stop), null).map(c => c.row);
    return [...curated, ...profilePhotos(view)].filter((photo, i, all) => all.findIndex(p => p.id === photo.id) === i);
};
export const leadProperty = (view, stop) => { var _a, _b; return (_b = (_a = tourLens(view, stop).properties[0]) !== null && _a !== void 0 ? _a : view.properties.find(isViewable)) !== null && _b !== void 0 ? _b : null; };
// Opens the platform's maps on the house. Google's universal link picks the app on a phone.
export const directionsUrl = (stop) => stop.lat === null || stop.lng === null
    ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(stop.address)}`
    : `https://www.google.com/maps/dir/?api=1&destination=${stop.lat},${stop.lng}`;
